import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Box, Avatar } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";

import { decryptId } from "../../Components/CryptoComponent";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const StaffDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const decryptedId = decryptId(decodeURIComponent(id));
  const navigate = useNavigate();

  const [staffData, setStaffData] = useState({});

  const getData = async () => {
    try {
      const res = await axiosAPI.get(`/Employee/listbyid/${decryptedId}`);
      const dataFromApi = res.data.data;
      setStaffData(dataFromApi);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const filterData = location?.state?.filterData || {
    name: "",
    passport_no: "",
    profession: "",
    branch: "",
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Box display="flex" alignItems="center">
        <CommonButton
          variant="outlined"
          background="#006CB8"
          onClick={() =>
            navigate("/Staffs", {
              state: { pagination: paginationState, filterData: filterData },
            })
          }
          margin="0px 20px 10px 0px"
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </CommonButton>

        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          mb={2}
        >
          Staff Details
        </Typography>
      </Box>

      {/* Personal Information Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist" }}
          >
            Personal Information
          </Typography>
        </Box>
        <Grid container spacing={2} alignItems="flex-start">
          {/* Avatar */}
          <Grid
            item
            xs={12}
            md={4}
            lg={4}
            xl={3}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Avatar
              src={
                staffData?.ED_Photo
                  ? `${process.env.REACT_APP_BASE_URL}/${staffData.ED_Photo}`
                  : undefined
              }
              sx={{
                width: 250,
                height: 250,
                border: "2px solid grey",
                cursor: "pointer",
              }}
            >
              {staffData?.ED_Name?.[0] || ""}
            </Avatar>

          </Grid>

          {/* Details */}
          <Grid item xs={12} md={8} lg={8} xl={9} container spacing={2}>
            {[
              { label: "Full Name", value: staffData?.ED_Name },
              { label: "Username", value: staffData?.ED_UserName },
              { label: "Date of Birth", value: staffData?.ED_Dateofbirth },
              { label: "Contact Number", value: staffData?.ED_ContactNumber },
              { label: "Email", value: staffData?.ED_Email },
              { label: "Address", value: staffData?.ED_Address },
            ].map((item, index) => (
              <Grid item xs={12} sm={4} md={6} xl={4} key={index}>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontFamily: "Geist",
                      fontSize: "18px",
                      mb: 0.5,
                    }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontFamily: "Geist, sans-serif",
                      fontSize: "16px",

                      /* important for long text */
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      whiteSpace: "normal",

                      /* optional safety */
                      maxWidth: "100%",
                    }}
                  >
                    {item.value && item.value !== "null" ? item.value : "-"}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>

      {/* Employment Details Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist" }}
          >
            Employment Details
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {[
            { label: "Designation", value: staffData?.ED_Designation_Name },
            { label: "Department", value: staffData?.ED_Department_Name },
            { label: "Branch", value: staffData?.ED_BranchName },
            {
              label: "Supervisor / Manager",
              value: staffData?.ED_ReportingPerson_Name,
            },
            {
              label: "Employment Status",
              value: staffData?.ED_EmploymentStatus_Name,
            },
            { label: "Date of Joining", value: staffData?.ED_Dateofjoin },
            { label: "Referal", value: staffData?.ED_Referal },
            { label: "Internal Notes", value: staffData?.ED_Remarks },
          ].map((item, index) => (
            <Grid item xs={12} sm={4} md={4} lg={4} xl={3} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label.replace(/_/g, " ")}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",

                    /* important for long text */
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",

                    /* optional safety */
                    maxWidth: "100%",
                  }}
                >
                  {item.value && item.value !== "null" ? item.value : "-"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Salary and Leave Details Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist" }}
          >
            Salary and Leave Details
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {[
            { label: "Salary", value: staffData?.ED_Salary },
            { label: "Pay Frequency", value: staffData?.ED_PayFrequency_Name },

            { label: "Maximum Leave (Days)", value: staffData?.ED_MaxLeave },
            {
              label: "Maximum Sick Leaves (Days)",
              value: staffData?.ED_SickLeave,
            },
            { label: "Bonus Info", value: staffData?.ED_BonusInfo },
          ].map((item, index) => (
            <Grid item xs={12} sm={4} md={4} lg={4} xl={3} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label.replace(/_/g, " ")}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",

                    /* important for long text */
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",

                    /* optional safety */
                    maxWidth: "100%",
                  }}
                >
                  {item.value && item.value !== "null" ? item.value : "-"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Actions */}
      <Grid container justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item sx={{ padding: "5px" }}>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() =>
              navigate("/Staffs", {
                state: { pagination: paginationState, filterData: filterData },
              })
            }
          >
            Cancel
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StaffDetails;
